export default function DataDef(menuName) {

    const columnMaps = new Map();

    // ClaimReportDetails
    const ClaimReportDetailsColumns = [
        { field: "SchemeId", headerName: 'Scheme Id', width: 150, description: 'SchemeId',hide:true, },
        { field: 'Scheme Name', headerName: 'Scheme Name', width: 280, description: 'Scheme Name', },
        { field: 'Year', headerName: 'Year', width: 100, description: 'Year', },
        { field: 'Month', headerName: 'Month', width: 100, description: 'Month', },
        { field: 'DistributorId', headerName: 'DistributorId', width: 150, hide: true, description: 'DistributorId', },
        { field: 'Distributor', headerName: 'Distributor', width: 150, description: 'Distributor', },
        { field: 'CustomerId', headerName: 'CustomerId', width: 160, hide: true, description: 'CustomerId', },
        { field: 'Customer', headerName: 'Customer', width: 200, description: 'Customer', },
        { field: 'City', headerName: 'City', width: 130, description: 'City', },
        { field: 'Salesman', headerName: 'Salesman', width: 130, description: 'Salesman', },
        { field: 'ItemId', headerName: 'ItemId', width: 150, description: 'ItemId', },
        { field: 'Item', headerName: 'Item', width: 150, description: 'Item', },
        { field: 'Depletion', headerName: 'Depletion', width: 80, description: 'Depletion', },
        { field: 'Slab Rate', headerName: 'Slab Rate', width: 80, description: 'Slab Rate', },
        { field: 'Claim Amount', headerName: 'Claim Amount', width: 150, description: 'Claim Amount', },
       
    ];

    columnMaps.set('claimreportcolumns', ClaimReportDetailsColumns);

    


    return columnMaps.get(menuName);

}
